/* eslint-disable */
import React, { Component } from 'react'
import MUIDataTable from 'mui-datatables'
import gql from 'graphql-tag'
import { Query, withApollo } from 'react-apollo'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import Divider from '@material-ui/core/Divider'
import Paper from '@material-ui/core/Paper'
import RegisterSIM from './RegisterSIM'
import FileSaver from 'file-saver'
import DetailsCard from './DetailsCard'
import ProviderSims from './ProviderSims'
import EditStatus from './EditStatus'
import getLoginId from '../../../utils/getLoginId'
import axios from 'axios'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar'
import EditSim from './EditSim'
import EditSimAdmin from './EditSimAdmin'
import Loader from '../../common/Loader'
import getAccountType from '../../../utils/getAccountType.js'

const style = theme => ({
  root: {
    padding: theme.spacing.unit * 4,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing.unit * 2
    },
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing.unit * 2,
    color: theme.palette.text.secondary
  },
  iconSmall: {
    fontSize: 20
  }
})

const GET_SIM_STOCK = gql`
  query getPartnerSimStockByServiceProvider($partnerLoginId: Int!) {
    sims: getPartnerSimStockByServiceProvider(partnerLoginId: $partnerLoginId) {
      serviceProviderName
      totalAssignedSim
      availableStock
      simProviderId
    }
  }
`
const GET_FILE_FORMAT = gql`
  query getPublicDownloadURL($bucketname: String!, $filename: String!) {
    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)
  }
`

const ALL_SIM_DETAILS = gql`
  query allSimDetails($partnerLoginId: Int!) {
    simStock: allSimDetails(ownerLoginId: $partnerLoginId) {
      id
      phoneNumber
      simNumber
      monthlyCharges
      status


      serviceProvider {
        name
        id
      }
    }
  }
`

const GET_SIM_LIST_BASIC = gql`
  query allSimDetails($partnerLoginId: Int!, $providerId: Int) {
    simList: allSimDetails(
      ownerLoginId: $partnerLoginId
      serviceProviderId: $providerId
    ) {
      id
      phoneNumber
      simNumber
      monthlyCharges
      status
      serviceProvider {
        name
        id
      }
    }
  }
`

const GET_SIM_LIST_WITH_DETAILS = gql`
  query allSimDetails($partnerLoginId: Int!, $providerId: Int) {
    simList: allSimDetails(
      ownerLoginId: $partnerLoginId
      serviceProviderId: $providerId
    ) {
      id
      phoneNumber
      simNumber
      monthlyCharges
      status
      clientName
      vehicleDetails {
        vehicleNumber

      }

      serviceProvider {
        name
        id
      }
    }
  }
`

class InventoryDevices extends Component {
  constructor(props) {
    super(props)
    this.classes = props
    this.simData = []
  }

  tableOptions = {
    selectableRows: false,
    responsive: 'scroll',
    rowsPerPage: 5,
    onRowClick: (rowData, dataIndex, rowIndex) => {
      if (rowData.length === 5) {
        let installationStatus
        if (rowData[4] === 'Yes') {
          installationStatus = 'Installed'
        } else {
          installationStatus = 'Not Installed'
        }
        this.setState({
          editStatusOpen: true,
          serviceProvider: rowData[0],
          simNumber: rowData[1],
          phoneNumber: rowData[2],
          monthlyCharges: parseInt(rowData[3], 10),
          isInstalled: installationStatus,
          currentSimId: this.state.currentSimIds[dataIndex.dataIndex],
          // prettier-ignore
          currentServiceProviderId: this.state.currentServiceProviderIds[dataIndex.dataIndex]
        })
      } else if (rowData.length === 4) {
        this.setState({
          editStatusOpen: true,
          serviceProvider: rowData[0],
          simNumber: rowData[1],
          phoneNumber: rowData[2],
          monthlyCharges: parseInt(rowData[3], 10),
          isInstalled: 'NA',
          currentSimId: this.state.currentSimIds[dataIndex.dataIndex],
          // prettier-ignore
          currentServiceProviderId: this.state.currentServiceProviderIds[dataIndex.dataIndex]
        })
      }
    }
  }

  tableOptions2 = {
    selectableRows: false,
    responsive: 'scroll',
    rowsPerPage: 5,

    onRowClick: (rowData, dataIndex, rowIndex) => {
      console.log(this.status[dataIndex.dataIndex], 'di')

      if (this.status[dataIndex.dataIndex] === 2) {
        if (
          localStorage.getItem('Account_type') === 'SA' ||
          localStorage.getItem('Account_type') === 'PA' ||
          localStorage.getItem('Account_type') === 'INV'
        )
          this.editSim(this.simId[dataIndex.dataIndex])
      } else {
        this.props.openSnackbar('Sim cannot be edited')
      }
    }
  }

  state = {
    open: false,
    tableColumns: [],
    tableData: null,
    tableOptions: [],
    enableButton: false,
    editStatusOpen: false,
    serviceProvider: '',
    simNumber: '',
    phoneNumber: '',
    monthlyCharges: '',
    selectedCategory: '',
    isInstalled: '',
    currentSimIds: [],
    currentServiceProviderIds: [],
    currentSimId: '',
    currentServiceProviderId: '',
    clickStatus: {
      Activated: false,
      Deactivated: false,
      'Safe Custody': false,
      Unknown: false
    },
    simStock: [],
    sims: [],
    selSimId: '',
    openEdit: false,
    openEdit2: false,
    tableVisible: false,
    tableLoading: false,
    fetchOptionsDialogOpen: false,
    selectedProviderId: null,
    includeClientVehicleDetails: false
  }

  handleClickOpen = () => {
    this.setState({ open: true })
  }

  handleClose = () => {
    this.setState({
      open: false,
      editStatusOpen: false,
      tableVisible: false,
      tableData: null
    })
  }

  handleOpenFetchOptionsDialog = (providerId) => {
    this.setState({
      fetchOptionsDialogOpen: true,
      selectedProviderId: providerId,
      includeClientVehicleDetails: false  // Reset checkbox to unchecked
    })
  }

  handleCloseFetchOptionsDialog = () => {
    this.setState({
      fetchOptionsDialogOpen: false,
      selectedProviderId: null,
      includeClientVehicleDetails: false
    })
  }

  handleFetchData = () => {
    const { selectedProviderId, includeClientVehicleDetails } = this.state
    this.setState({
      fetchOptionsDialogOpen: false,
      tableLoading: true,
      tableVisible: true
    }, () => {
      this.getProviderData(selectedProviderId, includeClientVehicleDetails)
    })
  }

  editSim = simId => {
    // console.log(uniqueDeviceId, 'demo')
    this.setState({ selSimId: simId }, () => {
      // console.log(this.state.selSimId, 'uid')
    })
    this.handleClickOpenEdit()
  }

  editSimSuperAdmin = simId => {
    // console.log(uniqueDeviceId, 'demo')
    this.setState({ selSimId: simId }, () => {
      // console.log(this.state.selSimId, 'uid')
    })
    this.handleClickOpenEditAdmin()
  }

  handleClickOpenEditAdmin = () => {
    this.setState({ openEdit2: true })
  }

  handleCloseEditAdmin = () => {
    this.setState({ openEdit2: false })
  }

  handleClickOpenEdit = () => {
    this.setState({ openEdit: true })
  }

  handleCloseEdit = () => {
    this.setState({ openEdit: false })
  }

  addBulkUpload = e => {
    this.props.history.push({
      pathname: '/home/inventory/sims/bulk-upload'
    })
  }

  addBulkDelete = e => {
    this.props.history.push({
      pathname: '/home/inventory/sims/bulk-delete'
    })
  }

  downloadBulkUpload = client => async event => {
    const { data } = await this.props.client.query({
      query: GET_FILE_FORMAT,
      variables: {
        bucketname: 'excel-templates',
        filename: 'simUpload.xlsx'
      },
      errorPolicy: 'all'
    })
    const res = await axios({
      url: data.getPublicDownloadURL,
      method: 'GET',
      headers: { Accept: 'application/vnd.ms-excel' },
      responseType: 'blob' // important
    })

    FileSaver.saveAs(new Blob([res.data]), 'sample.xlsx')
    // FileSaver.saveAs(data.getPublicDownloadURL, 'sample.xlsx')
  }

  downloadBulkDelete = client => async event => {
    const { data } = await this.props.client.query({
      query: GET_FILE_FORMAT,
      variables: {
        bucketname: 'excel-templates',
        filename: 'simDeleteTemplate.xlsx'
      },
      errorPolicy: 'all'
    })
    const res = await axios({
      url: data.getPublicDownloadURL,
      method: 'GET',
      headers: { Accept: 'application/vnd.ms-excel' },
      responseType: 'blob' // important
    })

    FileSaver.saveAs(new Blob([res.data]), 'sample.xlsx')
    // FileSaver.saveAs(data.getPublicDownloadURL, 'sample.xlsx')
  }

  componentDidMount() {
    this.handleClick(1)
    // this.getAllSimDetails()
    // this.getSimStock()
  }

  getAllSimDetails = async () => {
    const simStock = await this.props.client.query({
      query: ALL_SIM_DETAILS,
      variables: {
        partnerLoginId: getLoginId()
      },
      fetchPolicy: 'cache-and-network'
    })
    console.log('simStock', simStock)
    this.setState({ simStock: simStock.data.simStock })
  }

  getSimStock = async () => {
    const sims = await this.props.client.query({
      query: GET_SIM_STOCK,
      variables: {
        partnerLoginId: getLoginId()
      },
      fetchPolicy: 'network-only'
    })
    // console.log('sims', sims)
    this.setState({ sims: sims.data.sims })
  }

  handleClick = status => {
    console.log('status', status)
    let columns = []
    let data = []
    let category
    let simProviderIds = []
    let simIds = []
    let clickStatus = {
      Activated: false,
      Deactivated: false,
      'Safe Custody': false,
      Unknown: false
    }

    if (status === 1) {
      if ([1].includes(getLoginId())) {
        columns = [
          'SERVICE PROVIDER',
          'SIM NUMBER',
          'PHONE NUMBER',
          'COST (in Rs)',
          'INSTALLED',
          'CLIENT NAME',
          'PARTNER NAME',
          'VEHICLE NO'
        ]
      } else if ([2].includes(getLoginId())) {
        columns = [
          'SERVICE PROVIDER',
          'SIM NUMBER',
          'PHONE NUMBER',
          'COST (in Rs)',
          'INSTALLED',
          'CLIENT NAME',
          'VEHICLE NO'
        ]
      }
      category = 'Activated'
      clickStatus = {
        Activated: true,
        Deactivated: false,
        'Safe Custody': false,
        Unknown: false
      }

      this.simData.forEach(sim => {
        let tempData = []

        // make a check for statuses
        if (sim.status === 4 || sim.status === 2 || sim.status === 3) {
          simProviderIds.push(sim.serviceProvider.id)
          simIds.push(sim.id)
          tempData.push(sim.serviceProvider.name.toString())
          tempData.push(sim.simNumber.toString())
          tempData.push(sim.phoneNumber.toString())
          tempData.push(sim.monthlyCharges.toString())

          tempData.push('No')
          if (sim.clientName === null) {
            tempData.push('NA')
          } else {
            tempData.push(sim.clientName)
          }
          if ([1].includes(getLoginId())) {
            tempData.push("Taabi Mobility Private Limited")

          }          // to optimise the sim details 29th dec temp change
          sim.vehicleDetails
            ? tempData.push(sim.vehicleDetails.vehicleNumber.toString())
            : tempData.push('N/A')
          data.push(tempData)
        } else if (sim.status === 4) {
          simProviderIds.push(sim.serviceProvider.id)
          simIds.push(sim.id)
          tempData.push(sim.serviceProvider.name.toString())
          tempData.push(sim.simNumber.toString())
          tempData.push(sim.phoneNumber.toString())
          tempData.push(sim.monthlyCharges.toString())

          tempData.push('Yes')
          if (sim.clientName === null) {
            tempData.push('NA')
          } else {
            tempData.push(sim.clientName)
          }
          if ([1].includes(getLoginId())) {
            tempData.push("Taabi Mobility Private Limited")
          }// to optimise the sim details 29th dec temp change
          sim.vehicleDetails
            ? tempData.push(sim.vehicleDetails.vehicleNumber.toString())
            : tempData.push('N/A')
          data.push(tempData)
          data.push(tempData)
        }
      })
    } else {
      // console.log('else columns')
      columns = [
        'SERVICE PROVIDER',
        'SIM NUMBER',
        'PHONE NUMBER',
        'COST (in Rs)',
        'CLIENT NAME'
      ]

      if (status === 0) {
        category = 'Deactivated'
        clickStatus = {
          Activated: false,
          Deactivated: true,
          'Safe Custody': false,
          Unknown: false
        }
        this.simData.forEach(sim => {
          let tempData = []

          // make a check for statuses
          if (sim.status === 0) {
            simProviderIds.push(sim.serviceProvider.id)
            simIds.push(sim.id)
            tempData.push(sim.serviceProvider.name.toString())
            tempData.push(sim.simNumber.toString())
            tempData.push(sim.phoneNumber.toString())
            tempData.push(sim.monthlyCharges.toString())
            if (sim.clientName === null) {
              tempData.push('NA')
            } else {
              tempData.push(sim.clientName)
            }
            data.push(tempData)
          }
        })
      } else if (status === 99) {
        category = 'Safe Custody'
        clickStatus = {
          Activated: false,
          Deactivated: false,
          'Safe Custody': true,
          Unknown: false
        }
        this.simData.forEach(sim => {
          let tempData = []

          // make a check for statuses
          if (sim.status === 99) {
            simProviderIds.push(sim.serviceProvider.id)
            simIds.push(sim.id)
            tempData.push(sim.serviceProvider.name.toString())
            tempData.push(sim.simNumber.toString())
            tempData.push(sim.phoneNumber.toString())
            tempData.push(sim.monthlyCharges.toString())
            if (sim.clientName === null) {
              tempData.push('NA')
            } else {
              tempData.push(sim.clientName)
            }
            data.push(tempData)
          }
        })
      } else if (status === -1) {
        category = 'Unknown'
        clickStatus = {
          Activated: false,
          Deactivated: false,
          'Safe Custody': false,
          Unknown: true
        }
        this.simData.forEach(sim => {
          let tempData = []

          // make a check for statuses
          if (sim.status === -1) {
            simProviderIds.push(sim.serviceProvider.id)
            simIds.push(sim.id)
            tempData.push(sim.serviceProvider.name.toString())
            tempData.push(sim.simNumber.toString())
            tempData.push(sim.phoneNumber.toString())
            tempData.push(sim.monthlyCharges.toString())
            if (sim.clientName === null) {
              tempData.push('NA')
            } else {
              tempData.push(sim.clientName)
            }
            data.push(tempData)
          }
        })
      }
    }

    console.log('columns, data', columns, data)
    this.setState({
      tableData: data,
      tableColumns: columns,
      // selectedCategory: category,
      currentSimIds: simIds,
      currentServiceProviderIds: simProviderIds,
      tableOptions: this.tableOptions2
    })
  }

  handleProviderClick = async (providerId) => {
    console.log(providerId, 'providerId')
    this.handleOpenFetchOptionsDialog(providerId)
  }

  getProviderData = async (providerId, includeClientVehicleDetails = false) => {
    const query = includeClientVehicleDetails ? GET_SIM_LIST_WITH_DETAILS : GET_SIM_LIST_BASIC

    const simList = await this.props.client.query({
      query: query,
      variables: {
        partnerLoginId: getLoginId(),
        providerId: parseInt(providerId, 10)
      },
      fetchPolicy: 'network-only'
    })
    console.log('sims', simList)
    let columns = []
    let data = []
    this.status = []
    this.simId = []
    let simProviderIds = []
    let simIds = []

    // Build columns based on includeClientVehicleDetails
    if (includeClientVehicleDetails) {
      // WITH client and vehicle details
      if (localStorage.getItem('Account_type') === 'SA') {
        columns = [
          'SERVICE PROVIDER',
          'SIM NUMBER',
          'PHONE NUMBER',
          'COST (in Rs)',
          'INSTALLED',
          'CLIENT NAME',
          'PARTNER NAME',
          'VEHICLE NO'
        ]
      } else if (localStorage.getItem('Account_type') === 'PA') {
        columns = [
          'SERVICE PROVIDER',
          'SIM NUMBER',
          'PHONE NUMBER',
          'COST (in Rs)',
          'STATUS',
          'CLIENT NAME',
          'VEHICLE NUMBER'
        ]
      } else {
        columns = [
          'SERVICE PROVIDER',
          'SIM NUMBER',
          'PHONE NUMBER',
          'COST (in Rs)',
          'STATUS',
          'CLIENT NAME',
          'VEHICLE NUMBER'
        ]
      }
    } else {
      // WITHOUT client and vehicle details
      columns = [
        'SERVICE PROVIDER',
        'SIM NUMBER',
        'PHONE NUMBER',
        'COST (in Rs)',
        'STATUS'
      ]
    }

    simList.data.simList.forEach(sim => {
      console.log(sim)
      let tempData = []
      simProviderIds.push(sim.serviceProvider.id)
      simIds.push(sim.id)
      this.status.push(sim.status)
      this.simId.push(sim.id)

      // Always add these fields
      tempData.push(sim.serviceProvider.name.toString())
      tempData.push(sim.simNumber.toString())
      tempData.push(sim.phoneNumber.toString())
      tempData.push(sim.monthlyCharges.toString())
      tempData.push(this.getSimStatus(sim.status))

      // Conditionally add client and vehicle details
      if (includeClientVehicleDetails) {
        // Add CLIENT NAME
        if (sim.clientName === null) {
          tempData.push('NA')
        } else {
          tempData.push(sim.clientName)
        }

        // Add PARTNER NAME (only for SA)
        if ([1].includes(getLoginId())) {
          tempData.push('Taabi Mobility Private Limited')
        }// to optimise the sim details 29th dec temp change

        // Add VEHICLE NUMBER
        sim.vehicleDetails
          ? tempData.push(sim.vehicleDetails.vehicleNumber.toString())
          : tempData.push('N/A')
      }

      data.push(tempData)
    })

    console.log('on click data', data, columns)
    this.setState({
      tableData: data,
      tableColumns: columns,
      // selectedCategory: category,
      currentSimIds: simIds,
      currentServiceProviderIds: simProviderIds,
      tableOptions: this.tableOptions2,
      tableLoading: false
    })
  }

  getSimStatus = status => {
    if (status === 2) {
      return 'Instock'
    } else if (status === 3) {
      return 'Assigned to Client'
    } else if (status === 4) {
      return 'Registered to vehicle'
    } else if (status === 0) {
      return 'Deactivated'
    } else if (status === 99) {
      return 'safe Custody'
    } else if (status === 1) {
      return 'Added by super-admin'
    }
  }

  render() {
    const { classes } = this.props
    console.log(this.state)

    // SIM Card categories
    let simCategories = [
      {
        category: 'Activated',
        status: 1,
        count: 0,
        installed: 0,
        uninstalled: 0
      },
      {
        category: 'Deactivated',
        status: 0,
        count: 0,
        installed: 0,
        uninstalled: 0
      },
      {
        category: 'Safe Custody',
        status: 99,
        count: 0,
        installed: 0,
        uninstalled: 0
      },
      {
        category: 'Unknown',
        status: -1,
        count: 0,
        installed: 0,
        uninstalled: 0
      }
    ]

    // set currently selected
    let currentlySelected
    if (this.state.clickStatus['Activated'] === true) {
      currentlySelected = 'Activated SIMs'
    } else if (this.state.clickStatus['Deactivated'] === true) {
      currentlySelected = 'Deactivated SIMs'
    } else if (this.state.clickStatus['Safe Custody'] === true) {
      currentlySelected = 'Safe Custody SIMs'
    } else if (this.state.clickStatus['Unknown'] === true) {
      currentlySelected = 'Unknown SIMs'
    }
    console.log(this.state.tableOptions)
    return (
      <div className={classes.root}>
        <Dialog
          open={this.state.open}
          aria-labelledby="form-dialog-title"
        >
          <RegisterSIM handleClose={this.handleClose} />
        </Dialog>

        <Dialog
          open={this.state.editStatusOpen}
          aria-labelledby="edit-status-dialog"
        >
          <EditStatus
            handleClose={this.handleClose}
            category={this.state.selectedCategory}
            serviceProvider={this.state.serviceProvider}
            simNumber={this.state.simNumber}
            phoneNumber={this.state.phoneNumber}
            monthlyCharges={this.state.monthlyCharges}
            isInstalled={this.state.isInstalled}
            simId={this.state.currentSimId}
            serviceProviderId={this.state.currentServiceProviderId}
          />
        </Dialog>

        {/* Fetch Options Dialog */}
        <Dialog
          open={this.state.fetchOptionsDialogOpen}
          onClose={this.handleCloseFetchOptionsDialog}
          aria-labelledby="fetch-options-dialog"
        >
          <DialogTitle id="fetch-options-dialog-title">
            Fetch SIM Details
          </DialogTitle>
          <DialogContent>
            <Typography variant="body1" gutterBottom>
              Choose how you want to fetch the SIM data:
            </Typography>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.includeClientVehicleDetails}
                  onChange={(e) => this.setState({ includeClientVehicleDetails: e.target.checked })}
                  color="primary"
                />
              }
              label="Include Client and Vehicle Details"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseFetchOptionsDialog} color="default">
              Cancel
            </Button>
            <Button onClick={this.handleFetchData} color="primary" variant="contained">
              Fetch Data
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.openEdit}
          onClose={this.handleCloseEdit}
          aria-labelledby="form-dialog-title"
        >
          {
            <EditSim
              handleClose={this.handleCloseEdit}
              selSimId={this.state.selSimId}
            />
          }
        </Dialog>
        <Dialog
          open={this.state.openEdit2}
          onClose={this.handleCloseEditAdmin}
          aria-labelledby="form-dialog-title"
        >
          {
            <EditSimAdmin
              handleClose={this.handleCloseEditAdmin}
              selSimId={this.state.selSimId}
            />
          }
        </Dialog>

        <Grid container spacing={16} direction="row">
          {/* Upload and Bulk upload features  */}
          <Grid item xs={12}>
            <Grid container spacing={16} justify="space-between">
              <Grid item>
                <Typography variant="headline">
                  SIM Card Management
                </Typography>
              </Grid>
              <Grid item>
                {localStorage.getItem('Account_type') === 'SA' &&
                  window.location.host.includes('iocl') ? null : (
                  <Grid container spacing={8} justify="flex-end">
                    <Grid item xs={12} sm="auto">
                      <Button
                        fullWidth
                        color="secondary"
                        variant="contained"
                        className={
                          classes.button // href="/home/customers/add"
                        }
                        onClick={this.handleClickOpen}
                      >
                        Add SIM Card
                      </Button>
                    </Grid>
                    <Grid item xs={12} sm="auto">
                      <Button
                        fullWidth
                        color="secondary"
                        variant="contained"
                        className={classes.button}
                        onClick={this.addBulkUpload}
                      >
                        Bulk SIM Upload
                      </Button>
                    </Grid>
                    <Grid item xs={12} sm="auto">
                      <Button
                        fullWidth
                        color="secondary"
                        variant="contained"
                        className={classes.button}
                        onClick={this.addBulkDelete}
                      >
                        Bulk SIM Delete
                      </Button>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={8}>
              <Grid item xs={12}>
                <Typography
                  variant="subheading"
                  color="textSecondary"
                >
                  SIM Provider(s)
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Query
                  query={GET_SIM_STOCK}
                  variables={{
                    partnerLoginId: getLoginId()
                  }}
                  fetchPolicy="network-only"
                >
                  {({ loading, error, data }) => {
                    if (loading) return <Loader />
                    if (error) return `Error!: ${error}`
                    const { sims } = data
                    return (
                      <Grid container spacing={12}>
                        {sims.map(sim => {
                          console.log(sim, 'sim')
                          return (
                            <Grid item xs={12} sm={3} key={sim.simProviderId}>
                              <ProviderSims
                                provider={sim.serviceProviderName}
                                noOfSims={sim.totalAssignedSim}
                                handleProviderClick={() =>
                                  this.handleProviderClick(
                                    sim.simProviderId
                                  )
                                }
                                providerId={sim.simProviderId}
                              />
                              <Divider />
                            </Grid>
                          )
                        })}
                      </Grid>
                    )
                  }}
                </Query>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={8}>
              <Grid item xs={12}>
                <Typography
                  variant="subheading"
                  color="textSecondary"
                >
                  {/* {currentlySelected} */}
                  Sim Card Details
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {this.state.tableVisible ? (
                  this.state.tableLoading ? (
                    <Loader />
                  ) : (
                    <MUIDataTable
                      data={this.state.tableData}
                      columns={this.state.tableColumns}
                      options={this.state.tableOptions}
                    />
                  )
                ) : null}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default withStyles(style)(
  withApollo(withSharedSnackbar(InventoryDevices))
)



// WEBPACK FOOTER //
// ./src/components/Pages/InventorySims/index.jsx